'use client';

import React from "react";
import QRCard from "@/components/ui/QRCard/QRCard";
import { FacebookReviewSectionContent, GoogleReviewSectionContent, LanguageType } from "@/lib/types";

interface QRSectionProps {
  googleReviewSectionPageData: GoogleReviewSectionContent;
  facebookReviewSectionPageData: FacebookReviewSectionContent;
  language?: LanguageType;
}


const QRSection: React.FC<QRSectionProps> = ({
  googleReviewSectionPageData,
  facebookReviewSectionPageData,
  language = "english",
}) => {

  return (
    <section className="
      w-full
      flex items-center justify-center
      padding-main-x-mobile
      padding-main-x-desktop
      ">
      <div className="w-full container-large">
        <div
          className="
            w-full
            flex flex-col tb:flex-row tb:flex-wrap tb:flex-grow tb:gap-x-[1rem] tb:gap-y-[1.5rem]
            gap-y-[1rem]
          ">
          <QRCard
            type="dropdown"
            googleReviewSectionPageData={googleReviewSectionPageData}
            facebookReviewSectionPageData={facebookReviewSectionPageData}
            language={language}

            icon="facebook"
            href="https://www.facebook.com/rivive.sa/reviews"
          />

          <QRCard
            type="default"
            googleReviewSectionPageData={googleReviewSectionPageData}
            facebookReviewSectionPageData={facebookReviewSectionPageData}
            language={language}

            icon="google"
            href="https://g.page/r/CfDKP-3ZwwD9EBM/review"
          />

        </div>
      </div>
    </section>
  );
}


export default QRSection;
